module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_libao.e9cbf.png";